export default __webpack_public_path__ + "static/og-b61b8bf317cc5770703aaf170f4053db.png";